// extracted by mini-css-extract-plugin
export default {"container":"_H-z","error":"aI-z","disabled":"bI-z","submit":"cI-z","option":"dI-z","success":"eI-z","failure":"fI-z"};